import { BrowserRouter } from "react-router";
import { useAuthContext } from '../shared/contexts/authContext';
import LoggedRoutes from './logged.routes';
import AuthRoutes from './auth.routes';


export default function AppRoutes() {
  const { logged } = useAuthContext();
  return (
    <BrowserRouter>
      {logged ? <LoggedRoutes /> : <AuthRoutes />}
    </BrowserRouter>
  );
}
